export default __webpack_public_path__ + "static/3-6197f6e5b17ff2f6005d1a5fdf467982.jpeg";